module.exports = __webpack_public_path__ + "img/icon_privata.c66589c3.png";